import ButtonLarge from 'common/ButtonLarge';
import SubtextLarge from 'common/SubtextLarge';

import HeroSectionImage from '../../common/Images/Home/heroSection.png';
import { useNavigate } from 'react-router-dom';
import routes from 'config/routes';
import { userDetails as userDetailsAtom } from 'atoms';
import { useRecoilState } from 'recoil';

const HeroSection = () => {

    const navigate = useNavigate();
    const [user, setUser] = useRecoilState(userDetailsAtom)
    const isLoggedIn = user?.session?.access_token && user?.user?.id


    return (
        <div className="flex flex-col items-center gap-8 md:gap-20 pt-4 px-8 md:pt-8 md:px-12 xl:pt-16 xl:px-28 bg-[linear-gradient(to_bottom,_#FFF_90%,_#F5F1ED_10%)]">
            <div className="flex flex-col gap-6 w-[80%] max-w-[660px] items-center justify-center">
                <span className={`font-["Abril_Fatface"] font-normal leading-[70px] text-[60px] text-center text-[#555]`}>
                    Deliver the care your patients deserve.
                </span>
                <SubtextLarge className="text-center">
                    See any patient on your own terms and drastically reduce administrative overhead - without insurance
                    getting in the middle.
                </SubtextLarge>
                {!isLoggedIn && (
                    <ButtonLarge onClick={() => navigate(routes.auth.register)}>Get started - it's free</ButtonLarge>
                )}
            </div>

            <img src={HeroSectionImage} alt="Be Seen" />
        </div>
    );
};
export default HeroSection;
